const scoreData = [
  {
    title: '主食',
    val: 'staple',
    maxScore: 100,
    score: 100,
    list: [
      {
        name: '食材',
        type: 'type',
        val: 'p_staple_food_type',
        index: 0,
        disabled: false,
        select: [
          {
            text: '优选',
            less: 0
          },
          {
            text: '次选',
            less: -30
          },
          {
            text: '不推荐',
            less: -40
          },
          {
            text: '无',
            less: -100,
            disabledOther: true
          }
        ]
      },
      {
        name: '分量',
        type: 'weight',
        val: 'p_staple_weight_type',
        index: 0,
        disabled: false,
        select: [
          {
            text: '适量',
            less: 0
          },
          {
            text: '偏多',
            less: -30
          },
          {
            text: '偏少',
            less: -30
          },
          {
            text: '不明确',
            less: -20
          }
        ]
      },
      {
        name: '烹饪方式',
        type: 'method',
        val: 'p_staple_cooking_method_type',
        index: 0,
        disabled: false,
        select: [
          {
            text: '健康',
            less: 0
          },
          {
            text: '不健康',
            less: -20
          }
        ]
      }
    ]
  },
  {
    title: '蛋白质',
    val: 'protein',
    maxScore: 100,
    score: 100,
    list: [
      {
        name: '食材',
        type: 'type',
        val: 'p_protein_food_type',
        index: 0,
        disabled: false,
        select: [
          {
            text: '优选',
            less: 0
          },
          {
            text: '次选',
            less: -30
          },
          {
            text: '不推荐',
            less: -40
          },
          {
            text: '无',
            less: -100,
            disabledOther: true
          }
        ]
      },
      {
        name: '分量',
        type: 'weight',
        val: 'p_protein_weight_type',
        index: 0,
        disabled: false,
        select: [
          {
            text: '适中',
            less: 0
          },
          {
            text: '偏多',
            less: -30
          },
          {
            text: '偏少',
            less: -30
          },
          {
            text: '不明确',
            less: -20
          }
        ]
      },
      {
        name: '烹饪方式',
        type: 'method',
        val: 'p_protein_cooking_method_type',
        index: 0,
        disabled: false,
        select: [
          {
            text: '健康',
            less: 0
          },
          {
            text: '不健康',
            less: -20
          }
        ]
      }
    ]
  },
  {
    title: '蔬菜',
    val: 'vegetable',
    maxScore: 100,
    score: 100,
    list: [
      {
        name: '食材',
        type: 'type',
        val: 'p_vegetable_food_type',
        index: 0,
        disabled: false,
        select: [
          {
            text: '优选',
            less: 0
          },
          {
            text: '次选',
            less: -30
          },
          {
            text: '不推荐',
            less: -40
          },
          {
            text: '无',
            less: -100,
            disabledOther: true
          }
        ]
      },
      {
        name: '分量',
        type: 'weight',
        val: 'p_vegetable_weight_type',
        index: 0,
        disabled: false,
        select: [
          {
            text: '适中',
            less: 0
          },
          {
            text: '偏多',
            less: -30
          },
          {
            text: '偏少',
            less: -30
          },
          {
            text: '不明确',
            less: -20
          }
        ]
      },
      {
        name: '烹饪方式',
        type: 'method',
        val: 'p_vegetable_cooking_method_type',
        index: 0,
        disabled: false,
        select: [
          {
            text: '健康',
            less: 0
          },
          {
            text: '不健康',
            less: -20
          }
        ]
      }
    ]
  },
  {
    title: '油脂',
    val: 'grease',
    maxScore: 100,
    score: 100,
    list: [
      {
        name: '食材',
        type: 'type',
        val: 'p_grease_food_type',
        index: 0,
        disabled: false,
        select: [
          {
            text: '推荐',
            less: 0
          },
          {
            text: '不推荐',
            less: -40
          },
          {
            text: '无油脂',
            less: -100,
            disabledOther: true
          }
        ]
      },
      {
        name: '分量',
        type: 'weight',
        val: 'p_grease_weight_type',
        index: 0,
        disabled: false,
        select: [
          {
            text: '适中',
            less: 0
          },
          {
            text: '偏多',
            less: -30
          },
          {
            text: '偏少',
            less: -30
          }
        ]
      },
      {
        name: '烹饪方式',
        type: 'method',
        val: 'p_grease_cooking_method_type',
        index: 0,
        disabled: false,
        select: [
          {
            text: '健康',
            less: 0
          },
          {
            text: '不健康',
            less: -20
          }
        ]
      }
    ]
  },
  {
    val: 'taste',
    title: '饮食搭配',
    maxScore: 100,
    score: 100,
    list: [
      {
        name: '',
        type: 'type',
        val: 'p_taste_type',
        index: 0,
        disabled: false,
        select: [
          {
            text: '搭配合理',
            less: 0
          },
          {
            text: '搭配不合理',
            less: -50
          }
        ]
      }
    ]
  }
]
export { scoreData }
